var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileContractRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.7 363.3l-13.9-41.6c-3.3-9.8-12.4-16.4-22.8-16.4s-19.5 6.6-22.8 16.4L119 376.4c-1.5 4.6-5.8 7.6-10.6 7.6H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h12.4c18.6 0 35.1-11.9 41-29.5L160 354.6l16.8 50.5a16 16 0 0 0 14.1 10.9c.4 0 .8 .1 1.1 .1 6 0 11.6-3.4 14.3-8.9l7.7-15.3c2.8-5.6 7.9-6.2 10-6.2s7.3 .6 10.2 6.5c7.4 14.7 22.2 23.8 38.6 23.8H288c8.8 0 16-7.2 16-16s-7.2-16-16-16h-15.2c-4.3 0-8.1-2.4-10.2-6.5-11.9-23.9-46.2-30.3-66-14.2zM369.8 98L285.9 14.1c-9-9-21.2-14.1-33.9-14.1H48C21.5 .1 0 21.6 0 48.1v415.9C0 490.5 21.5 512 48 512h287.9c26.5 0 48.1-21.5 48.1-48V132c0-12.7-5.2-25-14.2-34zM256 52l76.1 76.1h-76.1V52zM336 464H48V48.1h160v104c0 13.3 10.7 24 24 24H336v288zM88 112h80c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0 64h80c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8z",
    fill: "grey"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileContractRegular);
export default __webpack_public_path__ + "static/media/file-contract-regular.a048af000e01be610b87bbfd10754783.svg";
export { ForwardRef as ReactComponent };